export const AIRBRAKE_IGNORED_ERROR_PATTERNS = [
  /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/
];

export const shouldIgnoreAirbrakeError = (message) => {
  if (typeof message !== "string") return false;
  return AIRBRAKE_IGNORED_ERROR_PATTERNS.some((pattern) => pattern.test(message));
};
